/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { DapiHttpResponse } from './dapi-http-response';

export type ApiFnOptional<P, R> = (http: HttpClient, rootUrl: string, params?: P, context?: HttpContext) => Observable<DapiHttpResponse<R>>;
export type ApiFnRequired<P, R> = (http: HttpClient, rootUrl: string, params: P, context?: HttpContext) => Observable<DapiHttpResponse<R>>;

/**
* Helper service to call API functions directly
*/
@Injectable({ providedIn: 'root' })
export class DapiService {
  protected http: HttpClient = inject(HttpClient);

  /**
   * Executes an API call, returning the response body only
   */
  invoke$<P, R>(fn: ApiFnRequired<P, R>, rootUrl: string,  params: P, context?: HttpContext): Observable<R>;
  invoke$<P, R>(fn: ApiFnOptional<P, R>, rootUrl: string,  params?: P, context?: HttpContext): Observable<R>;
  invoke$<P, R>(fn: ApiFnRequired<P, R> | ApiFnOptional<P, R>, rootUrl: string,  params: P, context?: HttpContext): Observable<R> {
    return this.invokeResponse$(fn, rootUrl, params, context).pipe(map(r => r.body));
  }

  /**
   * Executes an API call, returning the entire response
   */
  invokeResponse$<P, R>(fn: ApiFnRequired<P, R>, rootUrl: string, params: P, context?: HttpContext): Observable<DapiHttpResponse<R>>;
  invokeResponse$<P, R>(fn: ApiFnOptional<P, R>, rootUrl: string, params?: P, context?: HttpContext): Observable<DapiHttpResponse<R>>;
  invokeResponse$<P, R>(fn: ApiFnRequired<P, R> | ApiFnOptional<P, R>, rootUrl: string, params: P, context?: HttpContext): Observable<DapiHttpResponse<R>> {
    return fn(this.http, rootUrl, params, context).pipe(
      filter(r => r instanceof HttpResponse),
      map(r => r as DapiHttpResponse<R>)
    );
  }
}
